const reduce = (arr, fn, result, idx = 0) => {
  if (!Array.isArray(arr)) return result
  return idx < arr.length ? reduce(arr, fn, fn(result, arr[idx], idx, arr), idx += 1) : result
}

export default reduce
